import { AlphaFBoxIcon } from './AlphaFBoxIcon';

/**
 * author: GreenTurtwig
 * id 1E5D6AAB-6056-4CEE-88EC-87FBE2C84FF0
 * name alpha-f-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-f-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterFBoxIcon = AlphaFBoxIcon;
export default LetterFBoxIcon